import React, { Component } from 'react';
import axios from '../../axios';
import Alert from 'react-s-alert'
// import FormDropdown from '../../components/FormDropdown'
import { connect } from 'react-redux'
import fp from 'lodash/fp'
// import { penerima_item } from '../../constants/itemAnggaran'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import FormCekKartu from '../../components/FormCekKartu'
import { resetCekKartuState } from '../../actions/formCekKartuAction'
import qs from 'qs'

const initialState = {    
    no_rm               : "",
    tgl_transaksi       : moment().format('YYYY-MM-DD'),
    dateTransaksi       : moment(),
    disabledFormNoRM    : false,
    dataPeriksa         : [
        {
            item_periksa: "",
            harga: 0
        }
    ],
    isButtonLoading     : false,
    isLoading           : false,
}

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...initialState,
            dataPeriksa: [
                ...initialState.dataPeriksa
            ]
        }

        this.handleChange               = this.handleChange.bind(this);
        this.handleSubmit               = this.handleSubmit.bind(this);        
        this.handleChangeDatepicker     = this.handleChangeDatepicker.bind(this);
        this.handleTambahFormItemClick  = this.handleTambahFormItemClick.bind(this);
        this.handleNestedChange         = this.handleNestedChange.bind(this);
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({ [name]: value })        
    }

    handleNestedChange(event, index) {

        const value = event.target.value
        const name  = event.target.name

        const newState = fp.cloneDeep(this.state.dataPeriksa)
        
        newState[index][name] = value        

        this.setState({
            dataPeriksa: newState
        })
    }

    handleChangeDatepicker(momentObj) {

        this.setState({
            dateTransaksi: momentObj,
            tgl_transaksi: momentObj.format('YYYY-MM-DD')
        })
    }

    handleTambahFormItemClick() {

        const newState = [
            ...this.state.dataPeriksa,
            {
                item_periksa : "",
                harga        : 0
            }
        ]

        this.setState({
            dataPeriksa: newState
        })
    }

    handleHapusFormItem(index) {

        const newState = [
            ...this.state.dataPeriksa
        ]

        newState.splice(index, 1)

        this.setState({ dataPeriksa: newState })
    }

    handleSubmit() {

        this.setState({isButtonLoading: true})

        axios({
            method: 'post',
            url: '/rumah_sakit/saveTransaksi?id_kartu_saldo=' + this.props.id_kartu_saldo,
            data: qs.stringify(this.state)
        })
            .then(response => {
        
                const result = response.data;
        
                if (result.status !== 1) {
        
                    result.msg.map((item) => {
                        Alert.error(item)
        
                        return true;
                    })
        
                    this.setState({isButtonLoading: false})
                }
                else {
                    Alert.success(result.msg)
                    this.props.history.replace("/transaksi");
                }
        
                return true;
            })
            .catch(error => {
                console.log(error)
                this.setState({isButtonLoading: false})
                Alert.error("Gagal terhubung ke server!")
            })

    }

    loadRekamMedis() {

        axios.get("/rumah_sakit/getDataPasien?id_kartu_anggota=" + this.props.id_kartu_anggota + "&getOneRow=1")
            .then(response => {

                const result = response.data 

                if ( ! fp.isEmpty(result)) {
                    this.setState({ 
                        no_rm            : result.no_rm, 
                        disabledFormNoRM : true 
                    })
                }
                else {
                    this.setState({ 
                        no_rm            : "", 
                        disabledFormNoRM : false 
                    })
                }
            })
            .catch(error => {
                
                console.log(error)
                Alert.error("Gagal terhubung ke server!")
            })
    }

    componentDidMount() {        
        this.props.resetCekKartuState()

        this.setState({
            ...initialState,
            dataPeriksa: [
                ...initialState.dataPeriksa
            ]
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.id_kartu_anggota !== this.props.id_kartu_anggota) {

            this.loadRekamMedis()
        }
    }
    
    render() {

        return (
            <div className="col-sm-12">
                
                <FormCekKartu />
                                     
                <div style={{
                    display: this.props.isKartuValid && 
                        this.props.id_kartu_anggota !== "" &&
                        this.props.sudahTerdaftar ? 
                            'block' : 'none'
                }}>
                    
                    <div className="card">
                        <div className="card-header">
                            Informasi Transaksi
                        </div>
                        <div className="card-block">
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <label className="form-control-label">Nomor Rekam Medis</label>
                                    <div className="input-group">
                                        <input
                                            name="no_rm"
                                            type="text"
                                            className="form-control"
                                            placeholder="Nomor Rekam Medis"
                                            onChange={this.handleChange}
                                            value={this.state.no_rm}
                                            disabled={this.state.disabledFormNoRM}
                                        />                                    
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <label className="form-control-label">Tanggal Transaksi</label>
                                    <div className="input-group">
                                        <DatePicker
                                            selected={this.state.dateTransaksi}
                                            onChange={(momentObj) => {
                                                this.handleChangeDatepicker(momentObj)
                                            }}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                        />                                 
                                    </div>
                                </div>
                            </div>                                              
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            Data Item Transaksi 
                            <button 
                                className="btn btn-sm btn-primary pull-right" 
                                style={{marginTop: "2px"}}
                                onClick={this.handleTambahFormItemClick}
                            >
                                <i className="fa fa-plus"></i> Tambah form item
                            </button>
                        </div>
                        <div className="card-block">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th width="25">No</th>
                                        <th>Nama Item</th>
                                        <th>Harga</th>
                                        <th>Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>                                                                
                                {
                                    this.state.dataPeriksa.map((item, i) => (
                                        <tr key={"dataPeriksa" + i}>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td>
                                                <textArea 
                                                    name="item_periksa"
                                                    value={this.state.dataPeriksa[i].item_periksa}
                                                    className="form-control"
                                                    placeholder="Ketik item periksa.."
                                                    onChange={(event) => {
                                                        this.handleNestedChange(event, i)
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <div className="input-group">
                                                    <span className="input-group-addon">Rp </span>                    
                                                    <input 
                                                        name="harga"
                                                        type="number" 
                                                        value={this.state.dataPeriksa[i].harga}
                                                        className="form-control" 
                                                        placeholder="Biaya Periksa" 
                                                        onChange={(event) => {
                                                            this.handleNestedChange(event, i)
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <button 
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => this.handleHapusFormItem(i)}
                                                    disabled={i === 0}
                                                >
                                                    Hapus
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                }       
                                </tbody>
                            </table>   
                        </div>
                        <div className="card-footer">
                            <button className="btn btn-primary" onClick={this.handleSubmit}>
                                <i className="fa fa-check"></i> Selesai, dan simpan data transaksi
                            </button>
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    city_id             : state.authReducer.city_id,
    cekKartuState       : state.formCekKartu,
    isKartuValid        : state.formCekKartu.isKartuValid,
    id_kartu_anggota    : state.formCekKartu.id_kartu_anggota,
    sudahTerdaftar      : state.formCekKartu.sudahTerdaftar,
    id_kartu_saldo      : state.formCekKartu.id_kartu_saldo,
})

const mapDispatchToProps = (dispatch) => ({
    resetCekKartuState: () => {
        dispatch(resetCekKartuState())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Forms);


// WEBPACK FOOTER //
// ./src/views/Transaksi/Forms.js